const ID_TOKEN_KEY = "id_token";
const ID_USER_ID_KEY = "user_id";
const ID_USER_NAME_KEY = "user_name";
const ID_TANTOU_CODE_KEY = "tantou_id";
const ID_LEVEL_KEY = "level";

export const getToken = () => {
  return window.localStorage.getItem(ID_TOKEN_KEY);
};

export const saveToken = token => {
  window.localStorage.setItem(ID_TOKEN_KEY, token);
};

export const destroyToken = () => {
  window.localStorage.removeItem(ID_TOKEN_KEY);
};

export const getUserId = () => {
  return window.localStorage.getItem(ID_USER_ID_KEY);
};

export const saveUserId = userId => {
  window.localStorage.setItem(ID_USER_ID_KEY, userId);
};

export const destroyUserId = () => {
  window.localStorage.removeItem(ID_USER_ID_KEY);
};

export const getUserName = () => {
  return window.localStorage.getItem(ID_USER_NAME_KEY);
};

export const saveUserName = userName => {
  window.localStorage.setItem(ID_USER_NAME_KEY, userName);
};

export const destroyUserName = () => {
  window.localStorage.removeItem(ID_USER_NAME_KEY);
};

export const getTantouCode = () => {
  return window.localStorage.getItem(ID_TANTOU_CODE_KEY);
};

export const saveTantouCode = token => {
  window.localStorage.setItem(ID_TANTOU_CODE_KEY, token);
};

export const destroyTantouCode = () => {
  window.localStorage.removeItem(ID_TANTOU_CODE_KEY);
};

export const getLevel = () => {
  return window.localStorage.getItem(ID_LEVEL_KEY);
};

export const saveLevel = token => {
  window.localStorage.setItem(ID_LEVEL_KEY, token);
};

export const destroyLevel = () => {
  window.localStorage.removeItem(ID_LEVEL_KEY);
};

export default { 
  getToken, saveToken, destroyToken, 
  getUserId, saveUserId, destroyUserId,
  getUserName, saveUserName, destroyUserName,
  getTantouCode, saveTantouCode, destroyTantouCode,
  getLevel, saveLevel, destroyLevel
};